// EnquiryForm.js
import React, { useState } from 'react';

const EnquiryForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: '',
    });

    const phoneNumber = '8527203697'; // Your WhatsApp number with country code (no + or spaces)

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const { name, phone, email, message } = formData;

        const whatsappMessage = `Hello, I have an enquiry:\n\nName: ${name}\nEmail: ${email}\nMessage: ${message}`;
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;

        window.open(url, '_blank');
    };

    return (
        <form onSubmit={handleSubmit} style={styles.form}>
            <h2>Enquiry Form</h2>

            <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                style={styles.input}
            />
            <input
                type="phone"
                name="phone"
                placeholder="Mobile Number"
                value={formData.phone}
                onChange={handleChange}
                required
                style={styles.input}
            />
            <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
                style={styles.input}
            />

            <textarea
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={2}
                style={styles.textarea}
            />

            <button type="submit" style={styles.button}>Send via WhatsApp</button>
        </form>
    );
};

const styles = {
    form: {
        maxWidth: '400px',
        margin: '0 auto',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        background: '#fff',
    },
    input: {
        width: '100%',
        padding: '10px',
        marginBottom: '12px',
        borderRadius: '8px',
        border: '1px solid #ccc',
    },
    textarea: {
        width: '100%',
        padding: '10px',
        marginBottom: '12px',
        borderRadius: '8px',
        border: '1px solid #ccc',
    },
    button: {
        width: '100%',
        padding: '10px',
        borderRadius: '8px',
        border: 'none',
        backgroundColor: '#25D366',
        color: 'white',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
};

export default EnquiryForm;
